import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';

interface ConfirmDialogProps {
  isOpen: boolean;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmBtnColor?: string; // reactstrap color
  iconClass?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title = 'Please Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmBtnColor = 'primary',
  iconClass,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal fade isOpen={isOpen} toggle={onCancel} centered>
      <ModalBody className="py-4 px-5 text-center">
        {iconClass && <i className={`display-5 ${iconClass}`}></i>}
        <div className="mt-3">
          <h4>{title}</h4>
          <p className="text-muted mb-4">{message}</p>
        </div>
        <div className="d-flex justify-content-center gap-2">
          <Button
            type="button"
            color="light"
            onClick={onCancel}
            className="material-shadow-none"
          >
            {cancelLabel}
          </Button>
          <Button
            type="button"
            color={confirmBtnColor}
            onClick={onConfirm}
            className="material-shadow-none"
          >
            {confirmLabel}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmDialog;
